module.exports = __webpack_public_path__ + "static/img/200178.011da39c.png";